// Imports => Utilities
import { AcUUID } from '@utils';

// Imports => Constants
import { KEYS, TITLES } from '@constants';

export const OrderStamps = class {
	constructor(products) {
		this.products = products;

		return this.create();
	}

	create = () => {
		return {
			id: AcUUID(),
			type: KEYS.STAMPS,
			title: TITLES.ORDER_STAMPS,
			products: this.products.map(product => ({ ...product, value: '' })),
		};
	};
};

export default OrderStamps;
